var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.current
    ? _c(
        "span",
        {
          staticClass: "vuetify-wrapper mep24-integration-status",
          attrs: { "data-status": _vm.current.status },
        },
        [
          _c(
            "v-tooltip",
            {
              attrs: { top: "", "max-width": "360" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "v-chip",
                          _vm._g(
                            _vm._b(
                              { attrs: { "x-small": "", color: _vm.color } },
                              "v-chip",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [_vm._v("MEP24: " + _vm._s(_vm.label))]
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                757619201
              ),
            },
            [
              _vm._v(" "),
              _c(
                "span",
                [
                  _vm._v("\n            " + _vm._s(_vm.label)),
                  _c("br"),
                  _vm._v(" "),
                  _vm.current.action
                    ? [
                        _vm._v("Aktion: " + _vm._s(_vm.current.action)),
                        _c("br"),
                      ]
                    : _vm._e(),
                  _vm._v(
                    "\n            Versuche: " +
                      _vm._s(_vm.current.attempts || 0)
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _vm.current.last_attempt_at
                    ? [
                        _vm._v(
                          "Letzter Versuch: " +
                            _vm._s(_vm.current.last_attempt_at)
                        ),
                        _c("br"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.current.succeeded_at
                    ? [
                        _vm._v(
                          "Synchronisiert: " + _vm._s(_vm.current.succeeded_at)
                        ),
                        _c("br"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.current.remote_id
                    ? [
                        _vm._v("MEP24-ID: " + _vm._s(_vm.current.remote_id)),
                        _c("br"),
                      ]
                    : _vm._e(),
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.current.last_error && _vm.current.last_error.message
                      ) +
                      "\n        "
                  ),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _vm.current.can_retry
            ? _c(
                "v-btn",
                {
                  staticClass: "mep24-retry",
                  attrs: {
                    "x-small": "",
                    text: "",
                    loading: _vm.loading,
                    disabled: _vm.loading,
                  },
                  on: { click: _vm.retry },
                },
                [_vm._v("Erneut versuchen")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.error
            ? _c(
                "span",
                {
                  staticClass: "red--text mep24-error",
                  attrs: { role: "alert" },
                },
                [_vm._v(_vm._s(_vm.error))]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }